import Styled from 'styled-components'

export const Container = Styled.div`
margin: 0;
padding: 0;
`
export const ContainerProduct = Styled.div`

justify-content: space-between;

display: flex;

@media(max-width: 800px) {
 flex-direction: column;
 margin-top: 10px;
} 

`

export const Banner = Styled.div`
    position: relative;
    width: 100%;
    height: 100%;

.w-100{
    width: 100% !important;
}

.carousel-control-prev-icon{
    background-image: none !important;
}

.carousel-control-next-icon{
    background-image: none !important;
}

button{
    width: 8px !important;
    height: 8px !important;
    border-radius: 100% !important;
}

`

export const Content = Styled.div`
width: 100%;
margin-top: 40px;
padding: 0 32px;
h3 {
  font-size: 30px;
  font-weight: 400;
  word-wrap: break-word
}

`

export const Cashback = Styled.p`
color: white;
background-color: black;
font-size: 0.8rem;
text-align: center;
padding: 6px;

@media(max-width: 800px) {
    margin-top: 40px;
    font-size: 0.6rem; 
}

`

export const Title = Styled.h3`
font-size: 30px;
font-weight: 400;
line-height: 1.5;
letter-spacing: 0%;
color: #1D1D1F;
margin-bottom: 0;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;
`

export const Spots = Styled.p`
margin: 25px 0;
font-weight: bolder;
font-size: 28px;

span{
    font-size: 18px;
    color: black;
}

`
export const Details = Styled.p`
font-weight: 500;
style: medium;
font-size: 16px;
color: ${props => props.theme.whitelabel?.text_primary_color};
line-height: 150%;
letter-spacing: 0%;
`

export const CuttingStitches = Styled.del`
color: #757575;

`

export const Description = Styled.p`
font-weight: 400;
color: ${props => props.theme.whitelabel?.text_primary_color};
font-size: 14px;
line-height: 150%;
font-style: regular;
letter-spacing: 0%;
`

export const SoldBy = Styled.p`
color: #1D1D1F;
font-size: 12px;
font-weight: 700;
line-height: 150%;
letter-spacing: 0%;
margin-bottom: 16px;
margin-top: 0;
`

export const Brand = Styled.p`
color: #1D1D1F;
font-size: 14px;
font-weight: 700;
line-height: 150%;
letter-spacing: 0%;
margin-top: 8px;
margin-bottom: 0;
`

export const Space = Styled.div`
height: 50px;
`
export const CashbackInfo = Styled.div`
    background: ${props => props.theme.primary};
    height: 22px;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    p {
        color: #FAFBFF;
        text-align: center;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
    }
`

export const StarIcon = Styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 1;
`

export const VariationGrid = Styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 32px;
  margin-bottom: 32px;
`

export const VariationLabel = Styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #414141;
  line-height: 1.5;
  margin-bottom: 8px;
  display: block;
`

export const VariationSelect = Styled.select`
  width: 100%;
  border: none;
  border-bottom: 1px solid #1D1D1F;
  background: transparent;
  font-size: 16px;
  font-weight: 400;
  color: #1D1D1F;
  line-height: 1.5;
  padding: 4px 0;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2 4L6 8L10 4' stroke='%231D1D1F' stroke-width='1.5' fill='none'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 4px center;
  padding-right: 24px;
  cursor: pointer;
  font-family: var(--font-family);
`

export const AccordionWrapper = Styled.div`
  margin-top: 32px;
  padding-bottom: 80px;

  .accordion {
    border: none;
  }

  .accordion-item {
    border: none;
    background: transparent;
  }

  .accordion-header {
    border: none;
  }

  .accordion-button {
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 500;
    color: #1D1D1F;
    font-family: var(--font-family);

    &:not(.collapsed) {
      background: transparent;
      color: #1D1D1F;
      box-shadow: none;
    }

    &::after {
      background-size: 16px;
    }
  }

  .accordion-body {
    padding: 0 0 24px 0;
  }
`

export const ShippingPlaceholder = Styled.div`
  margin-top: 32px;
`

export const ProductDivider = Styled.hr`
  border: none;
  border-top: 0.75px solid #595959;
  margin: 56px 0 0 0;
`

export const FixedFooter = Styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: white;
  border-top: 1px solid #d9d9d9;
  padding: 16px 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`